export const backdropVariants = {
  initial: { opacity: 0 },
  exit: { opacity: 0 },
  animate: {
    opacity: 1,
  },
};
export const eventNameVariants = {
  initial: { opacity: 0 },
  exit: { opacity: 0, transition: { duration: 0.15 } },
  animate: {
    opacity: 1,
  },
};

export const subButtonVariants = {
  initial: { y: 0 },
  exit: {
    y: 0,
    transition: {
      duration: 0.2,
    },
  },
  animate: (custom) => ({
    y: -50 * custom,
  }),
};
